import { render, staticRenderFns } from "./mo-address-auto-form.html?vue&type=template&id=2fe84c56&external"
import script from "./mo-address-auto-form.ts?vue&type=script&lang=ts&external"
export * from "./mo-address-auto-form.ts?vue&type=script&lang=ts&external"
import style0 from "./mo-address-auto-form.vue?vue&type=style&index=0&id=2fe84c56&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/agent/_work/5/s/Be.Vlaanderen.Mo.Vue/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fe84c56')) {
      api.createRecord('2fe84c56', component.options)
    } else {
      api.reload('2fe84c56', component.options)
    }
    module.hot.accept("./mo-address-auto-form.html?vue&type=template&id=2fe84c56&external", function () {
      api.rerender('2fe84c56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/mo-address-auto-form/mo-address-auto-form.vue"
export default component.exports